import { useEffect } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import './_radio-button.scss';

const propTypes = {
	/**
	 * Atributo name asociado al input.
	 */
	name: PropTypes.string,
	/**
	 * Default value del input.
	 */
	value: PropTypes.string,
	/**
	 * Flag, ¿contiene error?
	 */
	error: PropTypes.bool,
	/**
	 * Flag, ¿estado exitoso?
	 */
	success: PropTypes.bool,
	/**
	 * Flag, ¿está deshabilitado?
	 */
	disabled: PropTypes.bool,
	/**
	 * Flag, ¿está seleccionado?
	 */
	checked: PropTypes.bool,
	/**
	 * Handler para los cambios.
	 */
	onChange: PropTypes.func,
	/**
	 * Handler para los cambios
	 * proviene del input box.
	 */
	setIsActive: PropTypes.func,
	/**
	 * Clases adicionales.
	 */
	className: PropTypes.string,
};

const defaultProps = {
	onChange: () => {},
	setIsActive: () => {},
};

const RadioButton = ({
	name,
	value,
	children,
	error,
	success,
	disabled,
	checked,
	onChange,
	setIsActive,
	className,
	...r
}) => {
	const classes = classNames('radio-button', className, {
		'state--error': error,
		'state--success': success,
	});

	useEffect(() => setIsActive(checked), [checked, setIsActive]);

	return (
		<label className={classes} {...r}>
			<input
				checked={checked}
				type="radio"
				name={name}
				value={value}
				disabled={disabled}
				onChange={onChange}
			/>
			<span>{children}</span>
		</label>
	);
};

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
